import { JobStatus } from "../../api/types/jobs/JobStatus";

export const allStatusList = [
  JobStatus.pending,
  JobStatus.active,
  JobStatus.stopped,
  JobStatus.finished,
];
